import EventEmitter from 'eventemitter3';

export default class ProjectManager extends EventEmitter {

    _styleConsole = 'background: #222; color: #ff8c8c';
    _classes = {
        projectItem: 'js-project-item',
        container: '',
        linkMoreLabel: 'label'

    };
    _height = {
        close: 0,
        open : 0
    };
    _linkMoreLabel = {
        open: '',
        close: ''
    }
    _showMoreOpened = false;
    _showMoreAnimated = false;

    constructor( { container = false } = null ) {
        super();

        this._container = ( container ) ? container : false;

        if( this._checkRequiredParams() == false )
            return;

        this._retrieveDOM();
        this._initClass();
        this.bind();
    }

    /**
     * Check if the mandatory parameters to create the object item are well informed
     * @return {Boolean}
     */
    _checkRequiredParams() {

        if( this._container == false || typeof this._container != 'object' ) {
            console.warn('%c The container is not defined ', this._styleConsole);
            return false;
        }
    }

    _retrieveDOM() {

        this._views = {};

        // Link More
        this._views.linkMore = {
            container: this._container.querySelector( '.' + this._classes.projectItem + '-link-more-container' ),
            button: false,
            label: false
        };
        if( this._views.linkMore.container ) {
            this._views.linkMore.button = this._views.linkMore.container.querySelector( '.' + this._classes.projectItem + '-link-more' );

            if( this._views.linkMore.button )
                this._views.linkMore.label = this._views.linkMore.button.querySelector( 'span.' + this._classes.linkMoreLabel );
        }

        // Content Project
        this._views.content = this._container.querySelector( '.' + this._classes.projectItem + '-content' );

        this._initDataDOM();
    }

    _initDataDOM() {
        this._getLinkLabel();
    }

    _getLinkLabel() {
        if( this._views.linkMore.container ) {
            this._linkMoreLabel.open = this._views.linkMore.container.dataset.linkLabelOpen;
        }

        if( this._views.linkMore.label ) {
            this._linkMoreLabel.close = this._views.linkMore.label.innerHTML;
        }
    }

    _initClass() {}

    bind() {

        window.addEventListener("load", (event) => {
            this._init();
        });

        if(  this._views.linkMore.button ) {
            this._views.linkMore.button.addEventListener( 'click', this._clickToggleMore.bind(this) );
        }
    }

    _init() {
        this._getHeightContent();
        this._initTimeline();
    }

    _getHeightContent() {

        if( this._views.content ) {
            let children = this._views.content.children;

            this._height.open = 0;
            if( children ) {
                for( let i = 0, j = children.length; i < j; i++ ) {
                    this._height.open += children[i].offsetHeight;
                }
            }
        }
    }

    _initTimeline() {
        this._initTlShowMore();
    }

    _initTlShowMore() {

        // Show More Open
        this._tlShowMoreOpen = new TimelineMax({
            paused : true,
            onStart: this._startAnimShowMoreOpen.bind(this),
            onComplete: this._endAnimShowMoreOpen.bind(this)
        });

        this._tlShowMoreOpen
            .to( this._views.content, 1, { height: this._height.open, ease: Power3.easeInOut } );


        // Show More Close
        this._tlShowMoreClose = new TimelineMax({
            paused : true,
            onStart: this._startAnimShowMoreClose.bind(this),
            onComplete: this._endAnimShowMoreClose.bind(this)
        });

        this._tlShowMoreClose
            .to( this._views.content, 1, { height: this._height.close, ease: Power3.easeInOut } );
    }

    // Start anim "SHOW MORE OPEN"
    _startAnimShowMoreOpen() {
        this._animLinkMoreLabel( this._linkMoreLabel.open );
        this._container.classList.add('open');
    }

    // End anim "SHOW MORE OPEN"
    _endAnimShowMoreOpen() {
        this._showMoreAnimated = false;
        this._showMoreOpened = true;

        this._showContent();

        this.emit( PROJECT_MANAGER_EVENT.SHOW_MORE_OPEN );
    }

    // Start anim "SHOW MORE CLOSE"
    _startAnimShowMoreClose() {
        this._container.classList.remove('show-project');
        this._animLinkMoreLabel( this._linkMoreLabel.close );

        setTimeout( () => {
            this._container.classList.remove('open');
        }, 600 );
    }

    // End anim "SHOW MORE CLOSE"
    _endAnimShowMoreClose() {
        this._showMoreAnimated = false;
        this._showMoreOpened = false;

        this.emit( PROJECT_MANAGER_EVENT.SHOW_MORE_CLOSE );
    }

    _animLinkMoreLabel( newLabel = '' ) {

        let tlLinkMoreLabel = new TimelineMax();
        tlLinkMoreLabel
            .to( this._views.linkMore.label, 0.2, { opacity: 0, ease: Power3.easeInOut, onComplete: () => {
                    setTimeout( () => {
                        this._setlinkMoreLabel(newLabel);
                    }, 250);
                }} )
            // .call( this.updatelinkLabel.bind(this), [ newLabel ] )
            .to( this._views.linkMore.label, 0.2, { opacity: 1, ease: Power3.easeInOut }, '+=0.3' )
    }

    _setlinkMoreLabel( newLabel ) {
        this._views.linkMore.label.innerHTML = newLabel;
    }

    _showContent() {
        this._container.classList.add('show-project');
    }

    _clickToggleMore( event ) {

        if( this._showMoreAnimated )
            return;

        this._showMoreAnimated = true;

        if( this._showMoreOpened ) {
            this._tlShowMoreClose.play(0);
        } else {
            this._tlShowMoreOpen.play(0);
        }
    }

    resize() {
        this._getHeightContent();
        this._initTlShowMore();

        if( this._showMoreOpened ) {
            this._setHeightContent();
        }
    }

    _setHeightContent() {
        this._views.content.style.height = this._height.open + 'px';
    }
}

export const PROJECT_MANAGER_EVENT = {
    'SHOW_MORE_OPEN' : '__pm_show_more_open',
    'SHOW_MORE_CLOSE' : '__pm_show_more_close'
}


// WEBPACK FOOTER //
// ./src/js/pages/history/modules/project-manager.js